import { Injectable } from '@angular/core';
import { Observable, EMPTY } from 'rxjs';
import { Command, CommandInterfaces, AppConfig, AbstractHttpCommand } from 'flux-core';
import { HttpHeaders } from '@angular/common/http';

/**
 * Supported user plan status changes.
 */
export enum UserPlanStatusChange {
    Resume = 'resume',
}

/**
 * Updates the user's subscription plan status through the GraphQL API.
 */
@Injectable()
@Command()
export class UpdateUserPlanStatus extends AbstractHttpCommand {

    public static get dataDefinition(): {}  {
        return {
            planStatus: true,
        };
    }

    public static get implements(): Array<CommandInterfaces> {
        return [ 'IGraphqlRestCommand' ];
    }

    /**
     * Http Headers required for this API to be called.
     */
    public get httpHeaders(): HttpHeaders {
        return new HttpHeaders({
            'creately-gravity-token': window.gravity.client.getCookie(),
        });
    }

    /**
     * Returns REST endpoint URL for this command
     */
    public get httpUrl(): string {
        return AppConfig.get( 'GRAPHQL_API_BASE_URL' );
    }

    public prepareData(): any {
        if ( !window.gravity.client.hasValidSession()) {
            return;
        }

        const planStatus = this.data?.planStatus;

        if ( !planStatus || !/^[a-zA-Z]+$/.test( planStatus )) {
            return;
        }

        this.data.query = `mutation{
            userUpdate(
                user: { planStatus: ${planStatus} }
            )
        }`;
    }

    /**
     * Command execute
     */
    public execute(): Observable<any> {
        // Not executing command if user is not authenticated
        if ( !window.gravity.client.hasValidSession() || !this.data?.query ) {
            return;
        }

        return EMPTY;
    }
}

Object.defineProperty( UpdateUserPlanStatus, 'name', {
    value: 'UpdateUserPlanStatus',
});
